<template>
  <div class="pa-0 ma-0 chat-page-container">
    <v-row no-gutters class="fill-height chat-container">
      <v-col cols="12" md="4" v-if="!isMobileChatOpen" class="group-list-col d-flex flex-column">
        <ChatGroupList
          :has-create-right="hasCreateRight"
          @open-broadcast-dialog="showBroadcastDialog = true"
          @open-create-dialog="showCreateDialog = true" />
      </v-col>

      <v-col md="4" v-if="$vuetify.breakpoint.mdAndUp" class="group-list-col d-flex flex-column"> </v-col>

      <transition name="fade">
        <v-col cols="12" md="8" v-if="activeView === 'pinboard'" class="message-view-col d-flex flex-column">
          <PinboardView @jump-to-message="jumpToMessage" />
        </v-col>
      </transition>

      <transition name="slide-in-right">
        <v-col cols="12" md="8" v-if="activeGroupId" class="message-view-col d-flex flex-column">
          <ChatMessageView />
        </v-col>
      </transition>

      <v-col md="8" v-if="$vuetify.breakpoint.mdAndUp && !activeGroupId && activeView !== 'pinboard'" class="message-view-col d-flex flex-column">
        <v-container class="fill-height" fluid>
          <v-row align="center" justify="center" class="fill-height">
            <v-col cols="12" class="text-center grey--text">
              <v-icon size="80" color="grey darken-2">mdi-chat-processing-outline</v-icon>
              <p class="mt-4 headline">Wähle eine Gruppe aus</p>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <UserProfileDialog />
    <BroadcastDialog v-model="showBroadcastDialog" />
    <chat-group-create-dialog v-if="hasCreateRight" v-model="showCreateDialog" @group-created="showCreateDialog = false" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import userService from "@/services/userService"

import ChatGroupList from "./components/chatGroupList.vue"
import ChatMessageView from "./components/chatMessageView.vue"
import ChatGroupCreateDialog from "./components/chatGroupCreateDialog.vue"
import UserProfileDialog from "./components/userProfileDialog.vue"
import BroadcastDialog from "./components/chatBroadcastDialog.vue"
import PinboardView from "./components/pinboardView.vue"

export default {
  name: "ChatView",
  components: {
    ChatGroupList,
    BroadcastDialog,
    ChatMessageView,
    ChatGroupCreateDialog,
    UserProfileDialog,
    PinboardView,
  },

  data() {
    return {
      showBroadcastDialog: false,
      showCreateDialog: false,
    }
  },

  computed: {
    ...mapState("chatStore", ["activeGroupId", "activeView"]),

    // Hilfs-Computed für Mobile Ansicht
    isMobileChatOpen() {
      return !this.$vuetify.breakpoint.mdAndUp && (this.activeGroupId || this.activeView === "pinboard")
    },

    hasCreateRight() {
      return userService.hasRight("stats_transactions")
    },
  },

  watch: {
    // Wenn ein Chat geöffnet wird, fügen wir einen State in die Browser-History ein
    activeGroupId(val) {
      if (val) {
        this.pushHistoryState()
      }
    },
    // Auch beim Pinboard
    activeView(val) {
      if (val === "pinboard") {
        this.pushHistoryState()
      }
    },
  },

  mounted() {
    // Event Listener für den Zurück-Button
    window.addEventListener("popstate", this.handlePopState)
  },

  beforeDestroy() {
    window.removeEventListener("popstate", this.handlePopState)
  },

  methods: {
    ...mapActions("chatStore", ["setActiveGroup"]),

    pushHistoryState() {
      // Wir pushen nur, wenn wir nicht schon im "Chat State" sind, um Duplikate zu vermeiden
      if (window.history.state && window.history.state.chatOpen) return

      window.history.pushState({ chatOpen: true }, "")
    },

    handlePopState(event) {
      // Wenn der User "Zurück" drückt und wir einen aktiven Chat haben:
      if (this.activeGroupId || this.activeView === "pinboard") {
        // Chat schließen (zurück zur Liste)
        this.setActiveGroup(null)
        // WICHTIG: Da 'popstate' durch das Drücken von Zurück ausgelöst wurde,
        // müssen wir nichts weiter tun. Der Browser hat die URL schon geändert.
      }
    },

    async jumpToMessage(pin) {
      const message = pin.messageId || pin
      const groupId = message.groupId._id || message.groupId
      await this.setActiveGroup(groupId)
    },
  },
}
</script>

<style lang="scss" scoped>
.chat-container {
  height: 100vh; /* Oder calc(100vh - navHeight) */
  overflow: hidden;
}

.group-list-col,
.message-view-col {
  height: 100%;
  overflow: hidden;
}

.group-list-col {
  border-right: 1px solid rgba(255, 255, 255, 0.05);
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
